import { TypePolicies } from '@apollo/client';

const typePolicies: TypePolicies = {
  Query: {
    fields: {
      collectors: {
        merge: true,
      },
    },
  },
  Survey: {
    fields: {
      links: {
        merge: true,
      },
    },
  },
  Team: {
    merge: true,
  },
  User: {
    fields: {
      features: {
        merge: true,
      },
      preferences: {
        merge: true,
      },
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export { typePolicies };
